<nav aria-label="breadcrumb">
  <ol class="breadcrumb">
    <li class="breadcrumb-item active" aria-current="page">
      <a [routerLink]="'/configuration/products-priority'">Brands priority list</a>
    </li>
    <li class="breadcrumb-item" aria-current="page">
      @if (isCreate()) {
        <span class="fs-5 fw-bold mb-0">Add product priority list</span>
      }
      @if (!isCreate()) {
        <span class="fs-5 fw-bold mb-0">Edit product priority list</span>
      }
    </li>
  </ol>
</nav>

@if (loaded) {
  <div class="card border-0 shadow mb-3 fade-in-zoom">
    <div class="card-body">
      <form [formGroup]="form" (ngSubmit)="onSubmit()">
        <div class="row g-3 mb-3">
          <div class="col-6">
            <label for="name" class="form-label">Name</label>
            <div class="input-group">
              <span class="input-group-text"><i class="bi bi-tag"></i></span>
              <input type="text" class="form-control" id="name" placeholder="Name"
                formControlName="name" (change)="nameChanged()">
            </div>
          </div>
          <div class="col-6">
            <label for="identifier" class="form-label">Identifier</label>
            <div class="input-group">
              <span class="input-group-text"><i class="bi bi-tag"></i></span>
              <input type="text" class="form-control" id="identifier" placeholder="Identifier"
                formControlName="identifier">
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-6">
            <div class="row">
              <div class="col-10 offset-1">
                <div
                  class="bg-tertiary p-2 border-start border-warning border-5 d-flex justify-content-between align-items-center mt-3 mb-5">
                  <h3 class="fw-bold fs-6 mb-0">Brands order list</h3>
                </div>
                @for (productPriorityProduct of getOrderedProducts(); track productPriorityProduct; let isFirst = $first; let isLast = $last) {
                  <div class="card shadow mb-3"
                    >
                    <div class="card-body d-flex justify-content-between">
                      <div class="logo me-1">
                        @if (productPriorityProduct.product?.logo) {
                          <img
                            [ngSrc]="imageService.getImageUrl($safeNavigationMigration(productPriorityProduct.product?.logo), 128, 128)" alt="Logo"
                            fill/>
                        }
                      </div>
                      <div class="text-center">
                        <span class="fw-bold fs-4">{{ productPriorityProduct.product?.name }}</span><br>
                        <div>
                          <span class="badge rounded-pill"
                            [ngClass]="{'text-bg-success': $safeNavigationMigration(productPriorityProduct.product?.enabled),'text-bg-danger':!productPriorityProduct.product?.enabled}">
                            {{ productPriorityProduct.product?.enabled ? 'enabled' : 'disabled' }}
                          </span>
                          <span class="badge rounded-pill ms-1"
                            [ngClass]="{'text-bg-success': $safeNavigationMigration(productPriorityProduct.product?.coreg),'text-bg-danger':!productPriorityProduct.product?.coreg}">P2
                          </span>
                          <span class="badge rounded-pill ms-1"
                            [ngClass]="{'text-bg-success': $safeNavigationMigration(productPriorityProduct.product?.cross),'text-bg-danger':!productPriorityProduct.product?.cross}">XSELL
                          </span>
                        </div>
                      </div>
                      <div class="text-end">
                        <button type="button" class="btn btn-primary fw-bold ms-1" [disabled]="isFirst"
                          (click)="up(productPriorityProduct)">
                          <i class="bi bi-arrow-up"></i></button>
                          <button type="button" class="btn btn-primary fw-bold ms-1" [disabled]="isLast"
                            (click)="down(productPriorityProduct)">
                            <i class="bi bi-arrow-down"></i></button>
                            <button type="button" class="btn btn-danger fw-bold ms-1" (click)="remove(productPriorityProduct)">
                              <i
                              class="bi bi-x"></i></button>
                            </div>
                          </div>
                        </div>
                      }
                    </div>
                  </div>
                </div>
                <div class="col-6">
                  <div class="row">
                    <div class="col-10 offset-1">
                      <div
                        class="bg-tertiary p-2 border-start border-warning border-5 d-flex justify-content-between align-items-center mt-3 mb-5">
                        <h3 class="fw-bold fs-6 mb-0">Available products</h3>
                      </div>
                      @for (product of getAvailableProducts(); track product) {
                        <div class="card shadow mb-3">
                          <div class="card-body d-flex justify-content-between">
                            <div class="logo">
                              @if (product.logo) {
                                <img
                                  [ngSrc]="imageService.getImageUrl(product.logo, 128, 128)" alt="Logo"
                                  fill/>
                              }
                            </div>
                            <div class="text-center">
                              <span class="fw-bold fs-4">{{ product.name }}</span><br>
                              <div>
                                <span class="badge rounded-pill"
                                  [ngClass]="{'text-bg-success': $safeNavigationMigration(product?.enabled),'text-bg-danger':!product?.enabled}">
                                  {{ product?.enabled ? 'enabled' : 'disabled' }}
                                </span>
                                <span class="badge rounded-pill ms-1"
                                  [ngClass]="{'text-bg-success': $safeNavigationMigration(product?.coreg),'text-bg-danger':!product?.coreg}">P2
                                </span>
                                <span class="badge rounded-pill ms-1"
                                  [ngClass]="{'text-bg-success': $safeNavigationMigration(product?.cross),'text-bg-danger':!product?.cross}">XSELL
                                </span>
                              </div>
                            </div>
                            <div class="text-end">
                              <button type="button" class="btn btn-success fw-bold ms-1" (click)="add(product)"><i
                              class="bi bi-plus"></i></button>
                            </div>
                          </div>
                        </div>
                      }
                    </div>
                  </div>
                </div>
              </div>
              <div class="row mt-5">
                <div class="col-12 text-end">
                  <button type="submit" class="btn btn-primary fw-bold" [disabled]="!canUpdate()">
                    @if (isCreate()) {
                      <span>Create</span>
                    }
                    @if (!isCreate()) {
                      <span>Update</span>
                    }
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      }
